import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Grid, Row, Col } from "react-bootstrap";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Paper from "@material-ui/core/Paper";
import "typeface-roboto";
import Modal from "react-modal";
import VrijwilligerForm from "./VrijwilligerForm";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)"
  }
};
const styles = {
  containerModal: {
    display: "flex",
    flexWrap: "wrap",
    fontSize: 14
  },
  container: {
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: "flex",
    flexDirection: "row"
    //alignItems: "center"
  },
  checkbox: {
    marginLeft: 16,
    width: 40
  },
  input: {
    flex: 1
    //alignContent: "flex-start",
    //justifyContent: "flex-start"
  },
  icongreen: {
    marginRight: 6,
    color: "green"
  },
  iconred: {
    marginRight: 6,
    color: "red"
  },
  subtitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "blue"
  },
  naam: {
    width: "90%"
    //alignSelf: "flex-start"
  },
  sluitbutton: {
    backgroundcolor: "#00FF00"
  }
};

const myVrijwilliger = {
  marginTop: 0,
  marginLeft: 20,
  //width: 200,
  float: "left",
  color: "blue"

  //fontSize: "24"
  //width: "80%"
};

class Vrijwilliger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = "blue";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
    //console.log(this.state.change);
  }
  static propTypes = {
    vrijwilliger: PropTypes.any
  };

  handleChange = name => event => {
    const { vrijwilliger, gebruikersNaam } = this.props;
    vrijwilliger.update({
      [name]: event.target.value,
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
  };

  render() {
    const { vrijwilliger, gebruikersNaam, gebruikersrollen } = this.props;
    const {
      voornaam,
      tussenvoegsel,
      achternaam,
      zz_lastupdate,
      zz_gebruikersNaam
    } = vrijwilliger.data;

    //console.log("TodoItem.render: ", vrijwilliger.path, ", text: ", text);
    return (
      <div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={[customStyles, "pre-scrollable"]}
          contentLabel="Wijzig vrijwilliger"
        >
          <h3
            style={styles.subtitle}
            ref={subtitle => (this.subtitle = subtitle)}
          >
            Wijzigen van: {voornaam} {tussenvoegsel || ""} {achternaam || ""}
          </h3>
          <div>
            <VrijwilligerForm
              vrijwilliger={vrijwilliger}
              gebruikersNaam={gebruikersNaam}
              gebruikersrollen={gebruikersrollen}
            />
          </div>
          <p />
          <Button variant="contained" color="primary" onClick={this.closeModal}>
            Sluit dit venster
          </Button>
          <h5 style={{ color: "#cecece", fontSize: 9 }}>
            Laatst gewijzigd door: {zz_gebruikersNaam} op {zz_lastupdate}{" "}
            {vrijwilliger.id}
          </h5>
          <form />
        </Modal>
        <Paper zdepth={1}>
          <Grid>
            <Row style={{ flex: 1, alignItems: "flex-start" }}>
              <Col xs={1} sm={1} lg={1} xl={1}>
                {gebruikersrollen.search("deletevrijwilligers") > -1 && (
                  <Button style={styles.iconred} onClick={this.onPressDelete}>
                    <DeleteIcon /> Verwijder
                  </Button>
                )}
              </Col>
              {/* <Col xs={1} sm={1}>
                <Button onClick={this.openModal}>
                  <EditIcon />
                </Button>
              </Col> */}
              <Col
                xs={5}
                sm={5}
                lg={5}
                xl={5}
                style={myVrijwilliger}
                bsClass="float-left"
                onClick={this.openModal}
              >
                {gebruikersrollen.search("editvrijwilligers") > -1 && (
                  <Button style={styles.icongreen} onClick={this.openModal}>
                    <EditIcon /> Wijzig instellingen van vrijwilliger{" "}
                    {voornaam || ""} {tussenvoegsel || ""} {achternaam || ""}.
                  </Button>
                )}
              </Col>
              {/* <Col
                xs={5}
                sm={5}
                lg={5}
                xl={5}
                style={myVrijwilliger}
                bsClass="float-left"
              >
                Tel: {telefoon || ""} of {backuptelefoon || " ---"}
              </Col> */}
            </Row>
          </Grid>
          <Divider />
        </Paper>
      </div>
    );
  }

  onPressDelete = async () => {
    if (
      window.confirm("Weet u zeker dat u deze vrijwilliger wilt verwijderen?")
    ) {
      const { vrijwilliger } = this.props;
      if (this._deleting) return;
      this._deleting = true;
      try {
        if (vrijwilliger.data.rollen) {
          alert(
            "Vrijwilliger heeft rollen (" +
              vrijwilliger.data.rollen +
              ") en kan niet verwijderd worden. Contact Pierre!!"
          );
        } else {
          await vrijwilliger.delete();
          this._deleting = false;
        }
      } catch (err) {
        this._deleting = false;
      }
    }
  };

  onPressCheck = async () => {
    const { vrijwilliger } = this.props;
    await vrijwilliger.update({
      finished: !vrijwilliger.data.finished
    });
  };

  onTextChange = async event => {
    const { vrijwilliger } = this.props;
    await vrijwilliger.update({
      text: event.target.value
    });
  };
}

export default observer(Vrijwilliger);



// WEBPACK FOOTER //
// ./src/components/Vrijwilligers/Vrijwilliger.jsx